import { User } from '@/types/user'

import api from './config'

interface SetupMfaParams {
  mfa: {
    phone: string
  }
}

interface VerifyMfaParams {
  mfa: {
    phone: string
    code: string
  }
}

export interface AuthenicateParams {
  session: {
    email: string
    password: string
    code: string
  }
}

interface AuthenticateResponse {
  user: User
  token: string
}

const mfaAPI = {
  setup: async (data: SetupMfaParams) => {
    const response = await api.post('/mfa/setup', data)
    return response.data
  },

  verify: async (data: VerifyMfaParams) => {
    const response = await api.post('/mfa/verify', data)
    return response.data
  },

  authenticate: async (data: AuthenicateParams) => {
    const response = await api.post<AuthenticateResponse>('/mfa/authenticate', data)
    return response.data
  }
}

export default mfaAPI